module.exports = __webpack_public_path__ + "static/1200-px-abc-news-solid-black-logo-svg@3x-59f3c295eea9155665383e597000dfae.png";